import { ApiFormEncoded, ApiJSON } from '@/api/insatances';
import { useEffect } from 'react';

export default function useBaseApiUrl() {
  const getApiUrl = (): string => {
    const { origin, hostname } = window.location;
    const { BASE_URL } = import.meta.env;

    if (hostname === 'localhost' && BASE_URL === '/') {
      return 'http://localhost:5174';
    }

    const path = BASE_URL.startsWith('/') ? BASE_URL : `/${BASE_URL}`;
    return origin + (path === '/' ? '' : path);
  };

  useEffect(() => {
    const baseURL = getApiUrl();
    ApiFormEncoded.defaults.baseURL = baseURL;
    ApiJSON.defaults.baseURL = baseURL;
  }, []);
}
